'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var nthHookLoma = require('@narvar/nth-hook-loma');
var graphql = require('./graphql.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LomaSettingsConfigContext = /*#__PURE__*/React__default["default"].createContext({
  product: 'narvarjs',
  retailerMoniker: 'DEFAULT_RETAILER',
  versionName: 'narvar'
});
const LomaSettingsConfigProvider = ({
  children,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(LomaSettingsConfigContext.Provider, {
  value: props
}, children);
const SettingsContext = /*#__PURE__*/React__default["default"].createContext(undefined);
const nullRetailerSettings = {}; // maintains obj ref equality
const LomaSettingsProvider = ({
  children,
  settingsRequested,
  additionalQueryProps
}) => {
  const client$1 = nthHookLoma.useLomaClient();
  const {
    product,
    retailerMoniker,
    versionName,
    localeLanguage,
    localeCountry,
    bannerName,
    status,
    category,
    type,
    cache
  } = React__default["default"].useContext(LomaSettingsConfigContext);
  const {
    loading,
    data
  } = client.useQuery(graphql["default"](settingsRequested), {
    client: client$1,
    variables: {
      product,
      retailerMoniker,
      versionName,
      localeLanguage,
      localeCountry,
      bannerName,
      status,
      category,
      type,
      cache,
      ...additionalQueryProps
    }
  });
  const settings = data?.retailerSettings ?? nullRetailerSettings;
  const value = React__default["default"].useMemo(() => ({
    loading,
    settings
  }), [loading, settings]);
  return /*#__PURE__*/React__default["default"].createElement(SettingsContext.Provider, {
    value
  }, children);
};
const SettingsProviderContext = /*#__PURE__*/React__default["default"].createContext(LomaSettingsProvider);
const SettingsProvider = ({
  children,
  ...props
}) => {
  const component = React__default["default"].useContext(SettingsProviderContext);
  return /*#__PURE__*/React__default["default"].createElement(component, props, children);
};
const withSettingsProvider = (component, options) => {
  const {
    settingsRequested,
    additionalQueryProps
  } = options;
  const HoC = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
    return /*#__PURE__*/React__default["default"].createElement(SettingsProvider, {
      settingsRequested,
      additionalQueryProps
    }, /*#__PURE__*/React__default["default"].createElement(component, {
      ...props,
      ref
    }));
  });
  const name = component.displayName ?? component.name;
  HoC.displayName = `WithSettingsProvider(${name})`;
  return HoC;
};
const useSettings = () => {
  const context = React__default["default"].useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings was called without a SettingsContext');
  }
  return context.settings;
};
const useSettingsX = () => {
  const context = React__default["default"].useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsX was called without a SettingsContext');
  }
  return context;
};
const LocalSettingsConfigContext = /*#__PURE__*/React__default["default"].createContext({
  querySettings: () => {
    throw new Error('Not implemented');
  }
});
const LocalSettingsProvider = ({
  children,
  ...props
}) => {
  const config = React__default["default"].useContext(LocalSettingsConfigContext);
  const value = config.querySettings(props);
  return /*#__PURE__*/React__default["default"].createElement(SettingsContext.Provider, {
    value
  }, children);
};
const LocalSettingsConfigProvider = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default["default"].createElement(SettingsProviderContext.Provider, {
    value: LocalSettingsProvider
  }, /*#__PURE__*/React__default["default"].createElement(LocalSettingsConfigContext.Provider, {
    value: props
  }, children));
};

exports.retailerSettingsQuery = graphql["default"];
exports.LocalSettingsConfigProvider = LocalSettingsConfigProvider;
exports.LocalSettingsProvider = LocalSettingsProvider;
exports.LomaSettingsConfigProvider = LomaSettingsConfigProvider;
exports.LomaSettingsProvider = LomaSettingsProvider;
exports.SettingsProvider = SettingsProvider;
exports.useSettings = useSettings;
exports.useSettingsX = useSettingsX;
exports.withSettingsProvider = withSettingsProvider;
